import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DprService } from '.';
import { DprApprover, DprOnlineApproval, DprDetails } from '@shared/models/dpr';

@Injectable()
export class DprApproversService {
  constructor(private dprService: DprService) {}

  createDprApprover(
    dprApprover: DprApprover,
    subprojectId: number
  ): Observable<DprApprover> {
    return this.dprService.action.createDprApprover(dprApprover, subprojectId);
  }

  updateDprApprover(
    dprApprover: DprApprover,
    subprojectId: number
  ): Observable<DprApprover> {
    return this.dprService.action.updateDprApprover(dprApprover, subprojectId);
  }

  deleteDprApprover(
    dprApproverId: number | string,
    subprojectId: number,
    dprDetailId: number | string
  ): Observable<void> {
    return this.dprService.action.deleteDprApprover(
      dprApproverId,
      subprojectId,
      dprDetailId
    );
  }

  syncDprOnlineApproval(
    dprOnlineApproval: DprOnlineApproval,
    subprojectId: number
  ): Observable<{
    dprOnlineApproval: DprOnlineApproval;
    dprDetail: DprDetails;
  }> {
    return this.dprService.action.syncDprOnlineApproval(
      dprOnlineApproval,
      subprojectId
    );
  }
}
